import React, { useState, useEffect } from "react";
import useStyles from "./style";
import { useHistory } from "react-router-dom";
import config from "../../config";

// components
import {
    CircularProgress, TextField, Select, FormControl, MenuItem, Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell
} from "@material-ui/core";
import Modal from "../modals/Modal";
import * as Icons from "@material-ui/icons";
import { Delete } from "@material-ui/icons";

const PayGroup = ({ partners }) => {
    const classes = useStyles();
    let history = useHistory();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [allPaymentMethods, setAllPaymentMethods] = useState([]);
    const [partnersPay, setPartnersPay] = useState([]);
    const [keyChange, setKeyChange] = useState(0);
    const [keyAddVoucher, setKeyAddVoucher] = useState(1);
    const [paymentIndex, setPaymentIndex] = useState(0);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const fetchPaymentMethods = async () => {
        if (!showModal) {
            fetch(baseUrl + "paymentMethod",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data.error != null) {
                        setShowModal(true);
                    } else {
                        setAllPaymentMethods(data);
                    }
                })
                .catch(error => null);
        }
    }

    useEffect(() => {
        setPartnersPay(partners);
        fetchPaymentMethods();
    }, []);

    const handleChange = (id, idPayment) => (e) => {
        const value = e.target.value;
        var partner = null;
        var indexOf = 0;
        var newList = partnersPay;

        for (var i = 0; i < partnersPay.length; i++) {
            var itemList = partnersPay[i];

            if (itemList.id == id) {
                partner = itemList;
                indexOf = partnersPay.indexOf(itemList);
            }
        }

        var payment;
        var indexOfPayment;
        var newPaymentList = partner.payment;
        for (var i = 0; i < partner.payment.length; i++) {
            var itemPayment = partner.payment[i];

            if (itemPayment.id == idPayment) {
                payment = {
                    id: itemPayment.id,
                    paymentMethod: value,
                    cash: itemPayment.cash,
                    transactionNumber: itemPayment.transactionNumber,
                    transactionCash: itemPayment.transactionCash
                };
                indexOfPayment = partner.payment.indexOf(itemPayment);
            }
        }

        newPaymentList[indexOfPayment] = payment;
        partner.payment = newPaymentList;
        newList[indexOf] = partner;
        setPartnersPay(newList);
        setKeyChange(keyChange + 1);
    }

    const onChange = (id, paymentMethod, idPayment) => (e) => {
        let start = e.target.selectionStart;
        let val = e.target.value;
        val = val.replace(/([^0-9.]+)/, "");
        val = val.replace(/^(0|\.)/, "");
        const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
        const value = match[1] + match[2];
        e.target.value = value;

        if (val.length > 0) {
            e.target.value = Number(value).toFixed(2);
            e.target.setSelectionRange(start, start);

            var partner = null;
            var indexOf = 0;
            var newList = partnersPay;

            for (var i = 0; i < partnersPay.length; i++) {
                var itemList = partnersPay[i];

                if (itemList.id == id) {
                    partner = itemList;
                    indexOf = partnersPay.indexOf(itemList);
                }
            }

            var payment;
            var indexOfPayment;
            var newPaymentList = partner.payment;
            for (var i = 0; i < partner.payment.length; i++) {
                var itemPayment = partner.payment[i];

                if (itemPayment.id == idPayment) {
                    if (paymentMethod == 'Efectivo') {
                        payment = {
                            id: itemPayment.id,
                            paymentMethod: itemPayment.paymentMethod,
                            cash: Number(value).toFixed(2),
                            transactionNumber: '',
                            transactionCash: ''
                        };
                    } else {
                        payment = {
                            id: itemPayment.id,
                            paymentMethod: itemPayment.paymentMethod,
                            cash: '',
                            transactionNumber: '',
                            transactionCash: Number(value).toFixed(2)
                        };
                    }
                    indexOfPayment = partner.payment.indexOf(itemPayment);
                }
            }

            newPaymentList[indexOfPayment] = payment;
            partner.payment = newPaymentList;
            newList[indexOf] = partner;
            setPartnersPay(newList);
        }
        setKeyChange(keyChange + 1);
    }

    const onChangeTransaction = (id, idPayment) => (e) => {
        var partner = null;
        var indexOf = 0;
        var newList = partnersPay;

        for (var i = 0; i < partnersPay.length; i++) {
            var itemList = partnersPay[i];

            if (itemList.id == id) {
                partner = itemList;
                indexOf = partnersPay.indexOf(itemList);
            }
        }

        var payment;
        var indexOfPayment;
        var newPaymentList = partner.payment;
        for (var i = 0; i < partner.payment.length; i++) {
            var itemPayment = partner.payment[i];

            if (itemPayment.id == idPayment) {
                payment = {
                    id: itemPayment.id,
                    paymentMethod: itemPayment.paymentMethod,
                    cash: itemPayment.cash,
                    transactionNumber: e.target.value,
                    transactionCash: itemPayment.transactionCash
                };
                indexOfPayment = partner.payment.indexOf(itemPayment);
            }
        }

        newPaymentList[indexOfPayment] = payment;
        partner.payment = newPaymentList;
        newList[indexOf] = partner;
        setPartnersPay(newList);
        setKeyChange(keyChange + 1);
    }

    function calculateTotal() {
        var newList = partnersPay;

        for (var i = 0; i < partnersPay.length; i++) {
            var itemList = partnersPay[i];
            var change = 0;
            var total = Number(itemList.totalPay);

            for (var q = 0; q < itemList.payment.length; q++) {
                var itemPaymentList = itemList.payment[q];

                if (itemPaymentList.paymentMethod == 'Efectivo') {
                    total = (Number(total) - Number(itemPaymentList.cash));
                } else {
                    total = (Number(total) - Number(itemPaymentList.transactionCash));
                }
            }

            change = Number(total) * -1;

            if (change >= 0.00) {
                itemList.change = Number(change);
                itemList.valid = 'true';
                newList[i] = itemList;
            } else {
                itemList.change = 0.00;
                itemList.valid = 'false';
                newList[i] = itemList;
            }

            setPartnersPay(newList);
        }
        setKeyChange(keyChange + 1);
    }

    const onSubmit = (id) => async e => {
        e.preventDefault();
        setIsLoading(true);
        var newList = partnersPay;
        var indexOf;
        var item;
        var list = [];
        var listPayment = [];

        for (var i = 0; i < partnersPay.length; i++) {
            var itemList = partnersPay[i];

            if (itemList.id == id) {
                item = itemList;
                indexOf = partnersPay.indexOf(itemList);
            }
        }

        list.push({
            id: item.id, price: item.totalPay, type: "Partner", amount: 1, discount: item.membershipDiscount, isForOneDay: false
        });

        for (var q = 0; q < item.payment.length; q++) {
            var itemPaymentList = item.payment[q];

            listPayment.push({
                paymentMethod: itemPaymentList.paymentMethod, cash: Number(itemPaymentList.cash),
                transactionNumber: Number(itemPaymentList.transactionNumber), transactionCash: Number(itemPaymentList.transactionCash)
            });
        }

        const sale = {
            idUser: localStorage.getItem('idUserSystem'), subTotal: item.subtotal, discount: item.membershipDiscount, totalToPay: item.totalPay,
            change: item.change, productSaleList: list, salePayment: listPayment
        };

        const response = await fetch(baseUrl + "createSale", {
            method: 'POST',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
            body: JSON.stringify(sale)
        });

        const json = await response.json();
        if (json.message == "Ok") {
            item.paid = true;
            newList[indexOf] = item;
            setPartnersPay(newList);
            setKeyChange(keyChange + 1);
            validateParners();
        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }

        setIsLoading(false);
    }

    const onAddPayment = (id) => (e) => {
        var partner = null;
        var indexOf = 0;
        var newList = partnersPay;

        for (var i = 0; i < partnersPay.length; i++) {
            var itemList = partnersPay[i];

            if (itemList.id == id) {
                partner = itemList;
                indexOf = partnersPay.indexOf(itemList);
            }
        }

        var payment = {
            id: paymentIndex,
            paymentMethod: "",
            cash: 0,
            transactionNumber: null,
            transactionCash: 0
        }

        var paymentList = partner.payment;
        paymentList.push(payment);

        partner.payment = paymentList;
        newList[indexOf] = partner;
        setPartnersPay(newList);
        setKeyChange(keyChange + 1);
        setPaymentIndex(paymentIndex + 1);
    }

    const onFinish = async e => {
        history.goBack();
    }

    function validateParners() {
        var allPaid = true;

        for (var i = 0; i < partnersPay.length; i++) {
            var itemList = partnersPay[i];

            if (!itemList.paid) {
                allPaid = false;
            }
        }

        if (allPaid) {
            history.goBack();
        }
    }

    const onDelete = (id, idPayment) => e => {
        e.preventDefault();
        var partner = null;
        var indexOf = 0;
        var newList = partnersPay;

        for (var i = 0; i < partnersPay.length; i++) {
            var itemList = partnersPay[i];

            if (itemList.id == id) {
                partner = itemList;
                indexOf = partnersPay.indexOf(itemList);
            }
        }

        var index = -1;
        
        for (var i = 0; i < partner.payment.length; i++) {
            var itemPayment = partner.payment[i];

            if (itemPayment.id == idPayment) {
                index = partner.payment.indexOf(itemPayment);
            }
        }

        if (index > -1) {
            var list = [];
            for (var i = 0; i < partner.payment.length; i++) {
                var item = partner.payment[i];
                if (index != i) {
                    list.push(item);
                }
            }
            partner.payment = list;
        }

        setPartnersPay(newList);
        setKeyChange(keyChange + 1);
    }

    function currencyFormat(num) {
        return '$ ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    return (
        <>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}

            {partnersPay.map((item) => (
                <>
                    <div className={classes.div} >
                        <div className={classes.divColumn}>
                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyleBold}>Nombre: </label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyle}>{item.name}</label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyleBold}>Membrecía: </label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyle}>{item.membershipType + " / " + item.groupType}</label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyleBold}>Costo de membrecía: </label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyle}>{currencyFormat(item.membershipCost)}</label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyleBold}>Descuento:</label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyle}>{currencyFormat(item.membershipDiscount)}</label>
                            </div>

                            {item.paidInscription == 1 ? (
                                <>
                                    <div className={classes.divPayTitle}>
                                        <label className={classes.payGroupStyleBold}>Costo de inscripción:</label>
                                    </div>

                                    <div className={classes.divPayTitle}>
                                        <label className={classes.payGroupStyle}>{currencyFormat(item.costInscription)}</label>
                                    </div>
                                </>
                            ) : (
                                <></>
                            )}

                            {item.isTraveler == 1 ? (
                                <>
                                    <div className={classes.divPayTitle}>
                                        <label className={classes.payGroupStyleBold}>Costo de viajero:</label>
                                    </div>

                                    <div className={classes.divPayTitle}>
                                        <label className={classes.payGroupStyle}>{currencyFormat(item.costTraveler)}</label>
                                    </div>
                                </>
                            ) : (
                                <></>
                            )}

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyleBold}>Subtotal:</label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyle}>{currencyFormat(item.subtotal)}</label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyleBold}>Total a pagar:</label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyle}>{currencyFormat(item.totalPay)}</label>
                            </div>
                        </div>

                        <Table className="mb-0" >
                            <TableHead>
                                <TableRow className={classes.rootTable} >
                                    <TableCell>Método</TableCell>
                                    <TableCell>Cantidad</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    {/*{keys.map(key => (
                                                <TableCell key={key}>{key}</TableCell>
                                            ))}*/}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {item.payment.map(({ id, paymentMethod }) => (
                                    <TableRow>
                                        <TableCell className={classes.tableRowStyleTitle} >
                                            <FormControl className={classes.formControl}>
                                                <Select
                                                    onChange={handleChange(item.id, id)}
                                                    displayEmpty
                                                    style={{ color: "#FFFFFF" }}
                                                >
                                                    <MenuItem value=""> Selecciona </MenuItem>
                                                    {allPaymentMethods.map((option) => (
                                                        <MenuItem value={option.name}>{option.name}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </TableCell>
                                        <TableCell className={classes.tableRowStyleTitle} >
                                            <div style={{ display: "flex" }}>
                                                <p style={{ fontSize: "16px", marginTop: "8px" }}> $ </p>
                                                <TextField
                                                    InputProps={{
                                                        classes: {
                                                            focused: classes.textBorder,
                                                            input: classes.inputPayGroup,
                                                        },
                                                    }}
                                                    onChange={onChange(item.id, paymentMethod, id)}
                                                    placeholder={"0"}
                                                    onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                                    onKeyUp={calculateTotal}
                                                    onBlur={calculateTotal}
                                                    style={{ width: '75%' }}
                                                    inputStyle={{ width: '75%' }}
                                                />
                                            </div>
                                        </TableCell>
                                        {paymentMethod != "Efectivo" && paymentMethod != "" ? (
                                            <TableCell className={classes.tableRowStyleTitle} >
                                                <p style={{ fontSize: "16px", marginTop: "8px" }}> # TRANSACCIÓN </p>
                                                <TextField
                                                    InputProps={{
                                                        classes: {
                                                            focused: classes.textBorder,
                                                            input: classes.inputPayGroup,
                                                        },
                                                    }}
                                                    onChange={onChangeTransaction(item.id, id)}
                                                    placeholder={"0"}
                                                    disabled={paymentMethod == "Efectivo" ? true : false}
                                                    onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                                    onKeyUp={calculateTotal}
                                                    onBlur={calculateTotal}
                                                    style={{ width: '75%' }}
                                                    inputStyle={{ width: '75%' }}
                                                />
                                            </TableCell>
                                        ) : (
                                            <>
                                            <TableCell className={classes.tableRowStyleTitle}/>
                                            </>
                                        )}                                        
                                        <TableCell className={classes.tableRowStyleTitle}>
                                            <div className={classes.divActionButtonDisable} >
                                                <Delete
                                                    classes={{ root: classes.searchIcon }}
                                                    onClick={onDelete(item.id, id)}
                                                />
                                            </div>
                                            </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell className={classes.tableRowStyleTitle} >
                                        <div className={classes.divAddButton} key={keyAddVoucher}>
                                            <Icons.Add classes={{ root: classes.searchIcon }}
                                                onClick={onAddPayment(item.id)}
                                            />
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>

                        <div className={classes.divColumn}>
                            <div className={classes.divPayTitle}>
                                <label className={classes.payGroupStyleBold}>Cambio:</label>
                            </div>

                            <div className={classes.divPayTitle}>
                                <label key={keyChange}
                                    className={classes.payGroupStyle}>{currencyFormat(item.change)}</label>
                            </div>
                        </div>

                        <div className={classes.divButton}>
                            {isLoading ? (
                                <div className={classes.loginLoader} >
                                    <CircularProgress size={26} />
                                </div>
                            ) : (
                                <>
                                    {item.paid ? (
                                        <div className={classes.loginLoader} >
                                            <p className={classes.textSuccess} >PAGADO</p>
                                        </div>
                                    ) : (
                                        <button
                                            className={item.valid == 'true' ? classes.enableButton : classes.disableButton}
                                            disabled={!(item.valid == 'true')}
                                            onClick={onSubmit(item.id)}
                                        >Pagar</button>
                                    )}
                                </>
                            )}

                        </div>
                    </div>

                    <div style={{ marginBottom: "60px" }} />
                </>
            ))}

            <div className={classes.divButton}>
                <button
                    className={classes.enableButton}
                    onClick={onFinish}
                >Finalizar</button>
            </div>
        </>
    );
}

export default PayGroup;